import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IFullTeamAssessment } from '../models/fullTeamAssessment';
import { ErrorService } from '../helpers/errorService';
import { IRMSPlanChecklist } from '../models/rmsPlanChecklist';

@Injectable({
  providedIn: 'root'
})
export class RMSPlanChecklistService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRmsPlanChecklistByCaseId(caseId: string): Observable<IRMSPlanChecklist> {
        const url = environment.apiBaseUrl + endpoints.getRMSPlanChecklistByCaseId.replace(':caseId', caseId);
        return this.http.get<IRMSPlanChecklist>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateRmsPlanChecklist(data: IRMSPlanChecklist): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRMSPlanChecklist;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}